/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ms_TitleInputs */

const en_ms_title = /** @type {(inputs: Ms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Milestones`)
};

const de_ms_title = /** @type {(inputs: Ms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilensteine`)
};

/**
* | output |
* | --- |
* | "Milestones" |
*
* @param {Ms_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ms_title = /** @type {((inputs?: Ms_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ms_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ms_title(inputs)
	return en_ms_title(inputs)
});